import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=548344d3&scoped=true&"
import script from "./NavMenu.vue?vue&type=script&lang=js&"
export * from "./NavMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548344d3",
  null
  
)

export default component.exports